var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditpreference(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 26.125H5C4.44687 26.125 4 26.5719 4 27.125V28.25C4 28.3875 4.1125 28.5 4.25 28.5H28.75C28.8875 28.5 29 28.3875 29 28.25V27.125C29 26.5719 28.5531 26.125 28 26.125ZM8.55313 23.5C8.61563 23.5 8.67813 23.4938 8.74063 23.4844L13.9969 22.5625C14.0594 22.55 14.1188 22.5219 14.1625 22.475L27.4094 9.22812C27.4383 9.19921 27.4613 9.16487 27.477 9.12707C27.4927 9.08927 27.5008 9.04874 27.5008 9.00781C27.5008 8.96688 27.4927 8.92636 27.477 8.88855C27.4613 8.85075 27.4383 8.81641 27.4094 8.7875L22.2156 3.59063C22.1563 3.53125 22.0781 3.5 21.9937 3.5C21.9094 3.5 21.8313 3.53125 21.7719 3.59063L8.525 16.8375C8.47812 16.8844 8.45 16.9406 8.4375 17.0031L7.51562 22.2594C7.48522 22.4268 7.49609 22.5991 7.54727 22.7613C7.59846 22.9236 7.68842 23.071 7.80937 23.1906C8.01562 23.3906 8.275 23.5 8.55313 23.5V23.5Z",
    fill: "#AAABAB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpreference);
export default __webpack_public_path__ + "static/media/editpreference.c36f5c7cdccdb71a528c377e22444bbd.svg";
export { ForwardRef as ReactComponent };